import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import WP from 'WP';
import api from 'api';

import css from 'css';

import { opportunityErrorMessage } from 'helpers';

import {
    setCheckoutTitle,
    setCheckoutSubtitle,
    setCheckoutNextCallback,
    setCheckountOpportunityEducationalGoal,
    setCheckoutOpportunityComment,
    setCheckoutOpportunityId,
    setCheckoutOpportunityAmount,
    setCheckoutOpportunityPayableAmount,
    setCheckoutError,
} from 'store';

const Wrapper = styled.section`
    textarea {
        width: 100%;
        height: 160px;
        padding: 15px;
        background: #E3EFFD;
        border: none;
        border-bottom: 4px solid ${css.colors.blue};
        border-radius: 0;
        font-family: inherit;
        font-size: inherit;
        outline: none;
    }
`;

const Description = styled.p`
    text-align: center;
    color: #FFFFFF;
    margin-bottom: 30px;
    font-size: 18px;
`;

const GoalList = styled.div`
    margin-bottom: 30px;

    .select-wrapper {
        user-select: none;
        width: 100%;
    }

    .select {
        display: flex;
        flex-direction: column;
    }

    .select-box {
        background: ${css.colors.main};
        display: flex;
        padding: 15px;
        align-items: center;
        border: 1px solid #FFFFFF;
        justify-content: space-between;
        color: #FFFFFF;
        cursor: pointer;
    }

    .options {
        position: absolute;
        display: none;
        top: 100%;
        left: 0;
        right: 0;
        border-top: 0;
        padding-bottom: 30px;
        transition: all 0.25s;
        pointer-events: none;
        z-index: 2;
    }

    .select.open .options {
        display: block;
        pointer-events: all;
    }

    .option {
        display: block;
        background: #fff;
        padding: 15px;
        border-bottom: 1px solid #CCC;
        cursor: pointer;
        transition: all 0.5s;

        &:last-child {
            border-bottom: none;
        }

        &:hover {
            cursor: pointer;
            background-color: #EEE;
        }
    }

    .arrow {
        height: 15px;
        width: 15px;

        &::before, ::after {
            position: absolute;
            content: "";
            bottom: 0px;
            width: 0.15rem;
            height: 100%;
            transition: all 0.5s;
        }

        &::before {
            left: -5px;
            transform: rotate(45deg);
            background-color: #FFFFFF;
        }

        &::after {
            left: 5px;
            transform: rotate(-45deg);
            background-color: #FFFFFF;
        }
    }

    .open .arrow {
        &::before {
            left: -5px;
            transform: rotate(-45deg);
        }

        &::after {
            left: 5px;
            transform: rotate(45deg);
        }
    }
`;

const InputRow = styled.div`
    display: flex;
    width: 100%;
    margin-bottom: 30px;
    align-items: center;

    textarea {
        width: 100%;
        height: 160px;
        padding: 15px;
        background: #E3EFFD;
        border: none;
        border-bottom: 4px solid ${css.colors.blue};
        font-family: inherit;
        font-size: inherit;
        outline: none;
    }
`

class Notes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dropdownActive: false,
        }
    }

    componentDidMount() {
        this.props.setCheckoutTitle('Tilleggsinformasjon');
        this.props.setCheckoutSubtitle('Er det noe spesielt du lurer på eller vil vi skal vite om?');
        this.props.setCheckoutNextCallback(this._onSubmit.bind(this));

        this.props.onRef(this);
    }

    _onHandleEducationalGoal = (event) => {
        const goal = event.target.getAttribute('data-value');

        this.props.setCheckountOpportunityEducationalGoal(goal);
    }

    _onHandleNoteChange = (event) => {
        this.props.setCheckoutOpportunityComment(event.target.value);
    }

    _onSubmit = () => {
        if (this.props.opportunity.id) {

            return this._onOpportunityUpdate().then((response) => {
                return true;
            }).catch(error => {
                this.props.setCheckoutError(opportunityErrorMessage(error, 'unableToRegister'));

                return false;
            });
        }

        return this._onOpportunityCreation().then((response) => {
                return true;
            }).catch(error => {
            this.props.setCheckoutError(opportunityErrorMessage(error, 'unableToRegister'));

            return false;
        });
    }
    
    _onOpportunityCreation() {
        const parameters = {
            customerId: this.props.opportunity.customerId,
            educationalGoal: this.props.opportunity.educationalGoal,
            attachments: this.props.opportunity.attachments,
            comment: this.props.opportunity.comment,
            programs: this.props.opportunity.programs,
            courses: this.props.opportunity.courses,
            transactionId: null,
            reservedAmount: 0,
            paymentMethod: null,
            coupon: this.props.opportunity.coupon,
            partialObject: this.props.opportunity.partialObject,
        }

        return api.createOpportunity(parameters).then(response => {
            this.props.setCheckoutOpportunityId(response.data.opportunityId);
            this.props.setCheckoutOpportunityAmount(response.data.opportunityValue);
            this.props.setCheckoutOpportunityPayableAmount(response.data.opportunityPayable);
        });
    }

    _onOpportunityUpdate() {
        const parameters = {
            customerId: this.props.opportunity.customerId,
            educationalGoal: this.props.opportunity.educationalGoal,
            attachments: this.props.opportunity.attachments,
            comment: this.props.opportunity.comment,
            programs: this.props.opportunity.programs,
            courses: this.props.opportunity.courses,
            transactionId: null,
            reservedAmount: 0,
            paymentMethod: null,
            coupon: this.props.opportunity.coupon,
            partialObject: this.props.opportunity.partialObject,
        }

        return api.updateOpportunity(this.props.opportunity.id, parameters).then(response => {
            this.props.setCheckoutOpportunityAmount(response.data.opportunityValue);
            this.props.setCheckoutOpportunityPayableAmount(response.data.opportunityPayable);
        });
    }

    render() {
        const { educationalGoal, comment } = this.props.opportunity;

        return (
            <Wrapper>
                <Description>
                    Legg gjerne inn en kommentar hvis det er noe spesielt du ønsker å sette lys på. For at 
                    vi skal kunne gi deg beste mulig rådgivning, er det flott hvis du kan identifisere hva det
                    gjelder i listen under. Dette er valgfritt:
                </Description>
                <GoalList>
                    <div className="select-wrapper" onClick={() => this.setState({ dropdownActive: !this.state.dropdownActive })}>
                        <div className={this.state.dropdownActive ? "select open" : "select"}>
                            <div className="select-box">
                                <span> {WP.trans.options.educational_goals[educationalGoal] || educationalGoal || 'Mitt studiemål'} </span>
                                <div className="arrow"></div>
                            </div>
                            <div className="options">
                                {WP.options.educational_goals.map(goal => {
                                    return (
                                        <span className="option" onClick={this._onHandleEducationalGoal.bind(this)} data-value={goal}>
                                            {WP.trans.options.educational_goals[goal] || goal}
                                        </span>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </GoalList>
                <InputRow>
                    <textarea placeholder="Jeg bare lurte på om..." value={comment || ''} onChange={this._onHandleNoteChange.bind(this)} />
                </InputRow>
            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    opportunity: state.opportunity,
});

const actions = {
    setCheckoutTitle,
    setCheckoutSubtitle,
    setCheckoutNextCallback,
    setCheckountOpportunityEducationalGoal,
    setCheckoutOpportunityComment,
    setCheckoutOpportunityId,
    setCheckoutOpportunityAmount,
    setCheckoutOpportunityPayableAmount,
    setCheckoutError,
}

export default connect(mapStateToProps, actions)(Notes);


// WEBPACK FOOTER //
// ./src/partials/Checkout/Notes.js